module.exports = __webpack_public_path__ + "img/e537a64.png";